import { Navigate, Outlet } from "react-router-dom";
import { getSessionItem } from "../../utils/helper/session";

export default function RoleRoute({ roles, children }) {
  const user = getSessionItem("User");
  const allowed = roles.includes(user?.roleName);

  if (!allowed) return <Navigate to="/unauthorized" replace />;
  return children ?? <Outlet />;
}
